export default __webpack_public_path__ + "static/media/relationOOTo.bc4b88ab.svg";